module.exports = __webpack_public_path__ + "media/images/country_flags/ne-fcba64fec1215eb416f74cf272c45806.png";